import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import ProductPropertyTab, { PropertyList } from '../../molecules/product-detail-accordion';

const ListWrapper = styled.div`
  display: flex;
`;

const List = styled(PropertyList)`
  list-style: none;
  margin-left: 0;
  flex: 1 1 0;
  max-width: 555px; /* 👀 */

  li {
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
    margin-left: 3rem;

    &::before {
      content: '';
      display: inline-block;
      height: 1.6rem;
      width: 1.6rem;
      background-image: url(${process.env.NEXT_PUBLIC_ASSET_HOST}/images/check-mark.svg);
      background-size: contain;
      background-repeat: no-repeat;
      position: absolute;
      left: -3rem;
      top: 0.4rem;
    }
  }
`;

const GoodToKnow = (props) => {
  if (!props.product) return null;

  const goodToKnow = props.product?.product_properties?.filter(
    (property) => property.property_name === 'Good to know'
  );

  if (!goodToKnow || goodToKnow.length === 0) return null;

  // breaks array into chunks of 4
  const [firstFour, lastFour = []] = goodToKnow.reduce((acc, cur, i) => {
    const idx = Math.floor(i / 4);
    acc[idx] = [].concat((acc[idx] || []), cur);
    return acc;
  }, []);

  return (
    <ProductPropertyTab title="Good to Know">
      <ListWrapper>
        <List element="ul" like="paragraph-2">
          {
            firstFour.map((item) =>
              // eslint-disable-next-line react/no-danger
              <li key={item.id} dangerouslySetInnerHTML={{ __html: item.value }} />)
          }
        </List>

        {
          lastFour && (
            <List element="ul" like="paragraph-2">
              {
                lastFour.map((item) =>
                  // eslint-disable-next-line react/no-danger
                  <li key={item.id} dangerouslySetInnerHTML={{ __html: item.value }} />)
              }
            </List>
          )
        }
      </ListWrapper>
    </ProductPropertyTab>
  );
};

GoodToKnow.propTypes = {
  product: PropTypes.object.isRequired
};

export default GoodToKnow;
